import { render } from "./Devices.vue?vue&type=template&id=0f2c8c20"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__